import { FC, useState } from "react";

type Lang = "en" | "pl" | "ua";

type LngBtnProps = {
  value: Lang;
  className?: string;
  onChange: (lng: Lang) => void;
};

export const LngBtn: FC<LngBtnProps> = ({
  value,
  onChange,
  className = "",
}) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (lng: Lang) => {
    onChange(lng);
    setOpen(false);
  };

  return (
    <div className="lng-wrapper">
      <button
        type="button"
        className={`lng-main ${className}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        {value.toUpperCase()}
      </button>

      {open && (
        <ul className="lng-dropdown">
          {["en", "pl", "ua"].map((l) =>
            l === value ? null : (
              <li key={l}>
                <button
                  className={className}
                  onClick={() => handleSelect(l as Lang)}
                >
                  {l.toUpperCase()}
                </button>
              </li>
            ),
          )}
        </ul>
      )}
    </div>
  );
};
